import { z } from 'zod';
import { InvalidArgumentError } from '@commander-js/extra-typings';

const schema = z
  .string()
  .transform((value) => JSON.parse(value))
  .pipe(z.record(z.unknown()));

export type TemplateParams = z.TypeOf<typeof schema>;

export function validateTemplateParams(value: string): TemplateParams {
  try {
    return schema.parse(value);
  } catch {
    throw new InvalidArgumentError('Value must be a valid JSON object string.');
  }
}
